import { useState, useEffect } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";

const LINKS = [
  { label: "Work", href: "#work" },
  { label: "About", href: "#about" },
  { label: "Experience", href: "#experience" },
  { label: "Expertise", href: "#skills" },
  { label: "Education", href: "#education" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#0A0B0E]/85 border-b border-[#222634]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="font-display font-extrabold text-xl sm:text-2xl tracking-tight">
          VR<span className="text-[#FF4D23]">.</span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-[#B6BDCB] hover:text-[#F5F6FA] transition-colors font-medium tracking-wide"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta-talk"
            className="inline-flex items-center gap-1.5 min-h-[44px] bg-[#FF4D23] text-[#0A0B0E] text-sm font-bold px-5 py-2.5 rounded-full hover:bg-[#ff6a45] transition-colors"
          >
            Let&apos;s Talk <ArrowUpRight size={16} />
          </a>
        </nav>
        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[#F5F6FA]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden backdrop-blur-xl bg-[#0A0B0E]/95 border-t border-[#222634] px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              onClick={() => setOpen(false)}
              className="text-base text-[#B6BDCB] hover:text-[#F5F6FA] font-medium"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-mobile-cta-talk"
            onClick={() => setOpen(false)}
            className="inline-flex items-center gap-1.5 min-h-[44px] bg-[#FF4D23] text-[#0A0B0E] text-sm font-bold px-5 py-2.5 rounded-full w-fit"
          >
            Let&apos;s Talk <ArrowUpRight size={16} />
          </a>
        </div>
      )}
    </header>
  );
}
